export default __webpack_public_path__ + "4b710f0bdde07c21f19eaee072f19b38.jpg";